import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import TextField from '@mui/material/TextField';
import { FormEvent, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { signInStart } from '../../store/auth/auth.action';
import MainLogo from '../ui/main-logo/main-logo.component';

const LoginForm = () => {
    const dispatch = useDispatch();

    const emailInput = useRef<HTMLInputElement>(null);
    const passwordInput = useRef<HTMLInputElement>(null);

    const [emailError, setEmailError] = useState(false);
    const [passwordError, setPasswordError] = useState(false);
    const [emailHeplerText, setEmailHeplerText] = useState('');
    const [passwordHelperText, setPasswordHelperText] = useState('');

    const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setEmailError(false);
        setPasswordError(false);
        if (!emailInput.current?.value) {
            setEmailError(true);
            setEmailHeplerText('Email obbligatoria');
        }
        if (!passwordInput.current?.value) {
            setPasswordError(true);
            setPasswordHelperText('Password obbligatoria');
        }
        if (!emailInput.current?.value || !passwordInput.current?.value) {
            return;
        }
        try {
            dispatch(
                signInStart(
                    emailInput.current?.value,
                    passwordInput.current?.value,
                    () => {}
                )
            );
        } catch (error) {
            console.log('user sign in failed', error);
        }
    };

    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 8,
                }}
            >
                <Box height={100} display={'flex'} justifyContent={'center'}>
                    <MainLogo variant={'blu'} />
                </Box>
                <Box component="form" onSubmit={handleSubmit} noValidate>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Email Address"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        error={emailError}
                        helperText={emailHeplerText}
                        inputRef={emailInput}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        error={passwordError}
                        helperText={passwordHelperText}
                        inputRef={passwordInput}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 3, mb: 2 }}
                    >
                        Accedi
                    </Button>
                </Box>
                <Box />
            </Box>
        </Container>
    );
};

export default LoginForm;
